import { FrameDelay } from "./FrameDelay"
import { formatBytes, ImageFile } from "../../shared/services"
import { MAX_FILE_MB } from "../config"

const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024

const ACCEPTED_TYPES = new Set(Object.values(ImageFile.TYPES_BY_EXTENSION))

// The message to show for a file that can't be a source, or null when it can.
export const validateEntryFile = (file: File, type: string) => {
  if (/\.(cur|ani|ico)$/i.test(file.name))
    return "That's already a cursor 😄 Drop an image instead — PNG, JPG, WEBP, SVG or GIF."
  if (!ACCEPTED_TYPES.has(type)) return `Can't read “${file.name}”. Try PNG, JPG, WEBP, SVG or GIF.`
  if (file.size > MAX_FILE_BYTES)
    return `“${file.name}” is ${formatBytes(file.size)} — the limit is ${MAX_FILE_MB} MB per file.`
  return null
}

export const sortByName = (files: File[]) =>
  [...files].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" }),
  )

// The source's most common frame delay becomes the one delay every frame plays for.
export const commonDelay = (delays: number[], fallback: number) => {
  const counts = new Map<number, number>()
  let best = fallback
  for (const delay of delays) {
    const count = (counts.get(delay) ?? 0) + 1
    counts.set(delay, count)
    if (count > (counts.get(best) ?? 0)) best = delay
  }
  return FrameDelay.clamp(best)
}
